
import userApi from "./apis/userApi"
import auditionApi from "./apis/auditionApi"
import menuApi from"./apis/menuApi"
import companyApi from "./apis/companyApi"
import reviewTaskApi from "./apis/reviewTaskApi"
import miscApi from "./apis/miscApi"

const api = {
  userApi,
  auditionApi,
  menuApi,
  companyApi,
  reviewTaskApi,
  miscApi
}

export default api;